export default "__VITE_ASSET__626a4f3b__"